// Product price counts from the old amount to the new one when an option changes it, with the difference underneath.
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const num = (text) => { const m = String(text).replace(/,/g, '').match(/\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const money = (v) => v.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  document.querySelectorAll('[id^="price-template"]').forEach((wrap) => {
    if (wrap.closest('section')?.querySelector('dk-sleepsack-options')) return;
    const item = () => wrap.querySelector('.price--on-sale .price-item--sale') || wrap.querySelector('.price__regular .price-item--regular');
    let last = num(item()?.textContent), written = null, frame, flash;
    const delta = document.createElement('div');
    delta.className = 'dk-price-delta';
    delta.style.cssText = 'font-size:1.3rem;color:rgba(var(--color-foreground),.65);margin-top:2px;min-height:1.8rem;';
    wrap.after(delta);
    new MutationObserver(() => {
      const el = item(); if (!el || el.textContent === written) return;
      const finalText = el.textContent, to = num(finalText), from = last;
      last = to;
      if (from == null || to == null || from === to) return;
      delta.textContent = (to > from ? '+ $' : '− $') + money(Math.abs(to - from));
      clearTimeout(flash); flash = setTimeout(() => { delta.textContent = ''; }, 6000);
      if (reduced) return;
      cancelAnimationFrame(frame);
      const t0 = performance.now();
      const step = (t) => {
        const k = Math.min(1, (t - t0) / 650), v = from + (to - from) * (1 - Math.pow(1 - k, 3));
        written = k < 1 ? finalText.replace(/[\d,]+(\.\d+)?/, money(v)) : finalText;
        el.textContent = written;
        if (k < 1) frame = requestAnimationFrame(step);
      };
      frame = requestAnimationFrame(step);
    }).observe(wrap, { childList: true, subtree: true, characterData: true });
  });
})();
